import { APIHandler } from "../../base";
import {
    CreateChatBotRequest,
    UpdateChatBotRequest
} from "../../../common/interfaces/admin/chat-bot.interface";

export const fetchChatBots = (companyId: number, knowledgeBaseUid?: string) =>
    APIHandler.get(`/admin/${companyId}/chatBots`, {
        params: knowledgeBaseUid ? { knowledgeBaseUid } : undefined
    });

export const fetchChatBot = (companyId: number, id: string) =>
    APIHandler.get(`/admin/${companyId}/chatBots/${id}`);

export const createChatBot = (companyId: number, data: CreateChatBotRequest) =>
    APIHandler.post(`/admin/${companyId}/chatBots`, data);

export const updateChatBot = (companyId: number, id: string, data: UpdateChatBotRequest) =>
    APIHandler.patch(`/admin/${companyId}/chatBots/${id}`, data);

export const deleteChatBot = (companyId: number, id: string) =>
    APIHandler.delete(`/admin/${companyId}/chatBots/${id}`);

export const downloadManifest = (companyId: number, id: string) =>
    APIHandler.get(`/admin/${companyId}/chatBots/${id}/manifest`, {
        responseType: "blob"
    });
